import React, { Component } from 'react'
import { TESTIMONIALS_VIDEO_ID } from '../../../../constants/IbcArcadeConstants'
import VideoComponentModal from '../../../IbcArcade/VideoComponentModal'
import {
  MainContainer,
  ThumbnailImgContainer,
  ThumbnailImgSection,
  ThumbnailVideo
} from './styledComponents'

class VideoTestimonial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      videoPlayState: false
    }
  }

  playVideo = () => {
    this.setState({
      videoPlayState: true
    })
  }

  closeVideoModal = e => {
    if (e) {
      e.stopPropagation()
    }
    this.setState({
      videoPlayState: false
    })
  }

  render() {
    const { videoPlayState } = this.state
    const {
      videoThumbnailUrl,
      videoId,
      excludeBottomMargin,
      videoAltText,
      isVideoThumbnail,
      thumbnailVideoUrl,
      id
    } = this.props
    return (
      <MainContainer
        id={id}
        onClick={this.playVideo}
        excludeBottomMargin={excludeBottomMargin}
      >
        {isVideoThumbnail ? (
          <ThumbnailVideo
            autoPlay
            muted
            loop
            poster={videoThumbnailUrl}
            data-keepplaying
            id="mautic-player-0"
            className="videoImage"
          >
            <source src={thumbnailVideoUrl} type="video/webm" />
          </ThumbnailVideo>
        ) : (
          <ThumbnailImgSection>
            <ThumbnailImgContainer
              alt={videoAltText}
              draggable={false}
              dataSrc={videoThumbnailUrl}
              className="lazyload"
            />
          </ThumbnailImgSection>
        )}

        <VideoComponentModal
          isOpen={videoPlayState}
          close={this.closeVideoModal}
          videoId={videoId}
        />
      </MainContainer>
    )
  }
}

VideoTestimonial.defaultProps = {
  videoThumbnailUrl: '',
  videoId: TESTIMONIALS_VIDEO_ID
}

export default VideoTestimonial



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PortfolioSection/VideoTestimonial/index.js